<template>
  <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
  <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.sample, collapsed: !expanded.sample }">
    <div class="info-card-content">
    <div v-if="!expanded.sample">
      <div class="info-row">
        <div class="icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path d="M0 16.1914V4.82303C0 3.82414 0.790087 3.01439 1.76471 3.01439H2.54902C2.87389 3.01439 3.13725 3.28431 3.13725 3.61727C3.13725 3.95023 2.87389 4.22015 2.54902 4.22015H1.76471C1.43983 4.22015 1.17647 4.49007 1.17647 4.82303V16.1914C1.17647 16.5243 1.43983 16.7942 1.76471 16.7942H18.2353C18.5602 16.7942 18.8235 16.5243 18.8235 16.1914V4.82303C18.8235 4.49007 18.5602 4.22015 18.2353 4.22015H17.451C17.1261 4.22015 16.8627 3.95023 16.8627 3.61727C16.8627 3.28431 17.1261 3.01439 17.451 3.01439H18.2353C19.2099 3.01439 20 3.82415 20 4.82303V16.1914C20 17.1902 19.2099 18 18.2353 18H1.76471C0.790086 18 0 17.1902 0 16.1914Z" fill="#374957"/>
            <path d="M9.60784 0V1.36652H8.98039V10.9322C8.98039 11.657 8.71597 12.3522 8.24529 12.8648C7.77461 13.3773 7.13623 13.6652 6.47059 13.6652C5.80495 13.6652 5.16657 13.3773 4.69589 12.8648C4.22521 12.3522 3.96078 11.657 3.96078 10.9322V1.36652H3.33333V0H9.60784ZM7.72549 5.4661H5.21569V10.9322C5.21569 11.2946 5.3479 11.6422 5.58324 11.8985C5.81858 12.1547 6.13777 12.2987 6.47059 12.2987C6.80341 12.2987 7.1226 12.1547 7.35794 11.8985C7.59328 11.6422 7.72549 11.2946 7.72549 10.9322V5.4661ZM7.09804 8.88241C7.26445 8.88241 7.42404 8.95439 7.54171 9.08253C7.65938 9.21067 7.72549 9.38446 7.72549 9.56567C7.72549 9.74688 7.65938 9.92067 7.54171 10.0488C7.42404 10.1769 7.26445 10.2489 7.09804 10.2489C6.93163 10.2489 6.77203 10.1769 6.65436 10.0488C6.5367 9.92067 6.47059 9.74688 6.47059 9.56567C6.47059 9.38446 6.5367 9.21067 6.65436 9.08253C6.77203 8.95439 6.93163 8.88241 7.09804 8.88241ZM5.84314 6.83262C6.00955 6.83262 6.16914 6.90461 6.28681 7.03274C6.40448 7.16088 6.47059 7.33467 6.47059 7.51588C6.47059 7.6971 6.40448 7.87089 6.28681 7.99902C6.16914 8.12716 6.00955 8.19915 5.84314 8.19915C5.67673 8.19915 5.51713 8.12716 5.39946 7.99902C5.28179 7.87089 5.21569 7.6971 5.21569 7.51588C5.21569 7.33467 5.28179 7.16088 5.39946 7.03274C5.51713 6.90461 5.67673 6.83262 5.84314 6.83262ZM7.72549 1.36652H5.21569V4.09957H7.72549V1.36652Z" fill="#374957"/>
            <path d="M10.3922 0V1.36652H11.0196V10.9322C11.0196 11.657 11.284 12.3522 11.7547 12.8648C12.2254 13.3773 12.8638 13.6652 13.5294 13.6652C14.1951 13.6652 14.8334 13.3773 15.3041 12.8648C15.7748 12.3522 16.0392 11.657 16.0392 10.9322V1.36652H16.6667V0H10.3922ZM12.902 9.56567C12.5255 9.56567 12.2745 9.29237 12.2745 8.88241C12.2745 8.47245 12.5255 8.19915 12.902 8.19915C13.2784 8.19915 13.5294 8.47245 13.5294 8.88241C13.5294 9.29237 13.2784 9.56567 12.902 9.56567ZM14.1569 6.83262C13.7804 6.83262 13.5294 6.55932 13.5294 6.14936C13.5294 5.7394 13.7804 5.4661 14.1569 5.4661C14.5333 5.4661 14.7843 5.7394 14.7843 6.14936C14.7843 6.55932 14.5333 6.83262 14.1569 6.83262ZM14.7843 3.41631H12.2745V1.36652H14.7843V3.41631Z" fill="#374957"/>
          </svg>
        </div>
        <p class="info-text-title">Sample:</p>
    </div>
    </div>
        <div v-else class="info-card-content-col-group">
            <div class="info-row">
                <div class="icon-container">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                    <path d="M0 16.1914V4.82303C0 3.82414 0.790087 3.01439 1.76471 3.01439H2.54902C2.87389 3.01439 3.13725 3.28431 3.13725 3.61727C3.13725 3.95023 2.87389 4.22015 2.54902 4.22015H1.76471C1.43983 4.22015 1.17647 4.49007 1.17647 4.82303V16.1914C1.17647 16.5243 1.43983 16.7942 1.76471 16.7942H18.2353C18.5602 16.7942 18.8235 16.5243 18.8235 16.1914V4.82303C18.8235 4.49007 18.5602 4.22015 18.2353 4.22015H17.451C17.1261 4.22015 16.8627 3.95023 16.8627 3.61727C16.8627 3.28431 17.1261 3.01439 17.451 3.01439H18.2353C19.2099 3.01439 20 3.82415 20 4.82303V16.1914C20 17.1902 19.2099 18 18.2353 18H1.76471C0.790086 18 0 17.1902 0 16.1914Z" fill="#374957"/>
                    <path d="M9.60784 0V1.36652H8.98039V10.9322C8.98039 11.657 8.71597 12.3522 8.24529 12.8648C7.77461 13.3773 7.13623 13.6652 6.47059 13.6652C5.80495 13.6652 5.16657 13.3773 4.69589 12.8648C4.22521 12.3522 3.96078 11.657 3.96078 10.9322V1.36652H3.33333V0H9.60784ZM7.72549 5.4661H5.21569V10.9322C5.21569 11.2946 5.3479 11.6422 5.58324 11.8985C5.81858 12.1547 6.13777 12.2987 6.47059 12.2987C6.80341 12.2987 7.1226 12.1547 7.35794 11.8985C7.59328 11.6422 7.72549 11.2946 7.72549 10.9322V5.4661ZM7.09804 8.88241C7.26445 8.88241 7.42404 8.95439 7.54171 9.08253C7.65938 9.21067 7.72549 9.38446 7.72549 9.56567C7.72549 9.74688 7.65938 9.92067 7.54171 10.0488C7.42404 10.1769 7.26445 10.2489 7.09804 10.2489C6.93163 10.2489 6.77203 10.1769 6.65436 10.0488C6.5367 9.92067 6.47059 9.74688 6.47059 9.56567C6.47059 9.38446 6.5367 9.21067 6.65436 9.08253C6.77203 8.95439 6.93163 8.88241 7.09804 8.88241ZM5.84314 6.83262C6.00955 6.83262 6.16914 6.90461 6.28681 7.03274C6.40448 7.16088 6.47059 7.33467 6.47059 7.51588C6.47059 7.6971 6.40448 7.87089 6.28681 7.99902C6.16914 8.12716 6.00955 8.19915 5.84314 8.19915C5.67673 8.19915 5.51713 8.12716 5.39946 7.99902C5.28179 7.87089 5.21569 7.6971 5.21569 7.51588C5.21569 7.33467 5.28179 7.16088 5.39946 7.03274C5.51713 6.90461 5.67673 6.83262 5.84314 6.83262ZM7.72549 1.36652H5.21569V4.09957H7.72549V1.36652Z" fill="#374957"/>
                    <path d="M10.3922 0V1.36652H11.0196V10.9322C11.0196 11.657 11.284 12.3522 11.7547 12.8648C12.2254 13.3773 12.8638 13.6652 13.5294 13.6652C14.1951 13.6652 14.8334 13.3773 15.3041 12.8648C15.7748 12.3522 16.0392 11.657 16.0392 10.9322V1.36652H16.6667V0H10.3922ZM12.902 9.56567C12.5255 9.56567 12.2745 9.29237 12.2745 8.88241C12.2745 8.47245 12.5255 8.19915 12.902 8.19915C13.2784 8.19915 13.5294 8.47245 13.5294 8.88241C13.5294 9.29237 13.2784 9.56567 12.902 9.56567ZM14.1569 6.83262C13.7804 6.83262 13.5294 6.55932 13.5294 6.14936C13.5294 5.7394 13.7804 5.4661 14.1569 5.4661C14.5333 5.4661 14.7843 5.7394 14.7843 6.14936C14.7843 6.55932 14.5333 6.83262 14.1569 6.83262ZM14.7843 3.41631H12.2745V1.36652H14.7843V3.41631Z" fill="#374957"/>
                  </svg>
                </div>
            </div>
            <div class="flex flex-col">
              <div v-if="sampleCard">
                <p class="info-text-title">Sample:</p>
                <p class="info-text mb-2 mt-1">{{ sampleCard.orderTestNames }}</p>
                <p class="info-text-title-date">Service Date: {{ sampleCard.serviceDate }}</p>
                <p class="sample-card-status">{{ sampleCard.status }}</p>
              </div>
          </div>
        </div>
        <div v-if="expanded.sample" class="action-icons">
          <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
            <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
          </div>
          <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
            <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
          </div>
          <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('sample')">
            <img src="@/assets/cardActions/collapse.svg" alt="Expand" />
          </div>
        </div>
        <div v-else class="flex flex-row items-center gap-2">
          <div class="action-icon" @click.stop="toggleCard('sample')">
            <img src="@/assets/cardActions/expand.svg" alt="Collapse" />
          </div>
          <div class="drag-handle action-icon">
            <img src="@/assets/cardActions/move.svg" alt="Move" />
          </div>
        </div>
      </div>
      <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
        <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
          <template #prefix>
            <img src="@/assets/cardActions/move.svg" alt="Move" />
          </template>
        </FoldableButton>
        <div class="flex flex-row gap-1 justify-end">
          <FoldableButton text="View">
            <template #prefix>
              <img src="@/assets/cardActions/view.svg" alt="View" />
            </template>
          </FoldableButton>
          <FoldableButton text="Resend">
            <template #prefix>
              <img src="@/assets/cardActions/resend.svg" alt="Resend" />
            </template>
          </FoldableButton>
        </div>
      </div>
  </div>
</transition>


</template>
<script setup>
import { ref, computed } from 'vue'
import { useMyPatientsStore } from '@/store/helpers'
import { useCardActions } from '@/composables/useCardActions'

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
cardData: {
  type: Object,
  default: () => ({})
},
sampleCard: {
  type: Object,
  default: () => ({})
},
showFooter: {
  type: Boolean,
  default: true
}
})


const { patientInfoStore } = useMyPatientsStore()
// Define emits
const emit = defineEmits(['pin-card', 'unpin-card'])

// Use the card actions composable
const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit)

const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};


// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};

const expanded = ref({
  sample: true,
})

const toggleCard = (cardType) => {
expanded.value[cardType] = !expanded.value[cardType]
}

import { getCurrentPatientId } from '@/utils/patientUtils';

// Get sample data from store
const sampleCard = computed(() => {
  return patientInfoStore.getters.getSampleCardData(props.patient, props.cardData.entity_id) || {
    id: 'N/A',
    date: 'N/A',
    status: 'N/A',
    type: 'N/A',
  }
})


</script>


<style scoped>

.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}
.peg-board-title {
font-family: 'Inter', sans-serif;
font-weight: 500;
font-size: 22px;
color: #ffffff;
text-align: center;
margin-bottom: 16px;
}

.peg-board-content {
display: flex;
flex-direction: column;
gap: 6px;
overflow-y: auto;
padding: 0 8px;
}

.info-card {
background-color: white;
border-radius: 5px;
padding: 12px 16px;
box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
display: flex;
justify-content: space-between;
align-items: flex-start;
gap: 16px;
}

.info-card-content-col-group {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.info-row-group {
display: flex;
flex-direction: column;
gap: 10px;
flex-grow: 1;
}

.info-row {
display: flex;
align-items: center;
gap: 8px;
}

.icon-container {
background-color: #f2f2f2;
border-radius: 4px;
width: 24px;
height: 24px;
display: flex;
justify-content: center;
align-items: center;
}

.icon-style {
width: 20px;
height: 20px;
}

.info-text {
font-family: 'Inter', sans-serif;
font-size: 14px;
color: #333333;
letter-spacing: 0.25px;
line-height: 20px;
}

.action-icons {
display: flex;
flex-direction: column;
gap: 4px;
}

.action-icon {
width: 24px;
height: 24px;
cursor: pointer;
}

.appointment-date {
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-between;
width: 50px;
height: 64px;
border-radius: 5px;
background-color: #ffffff;
box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
overflow: hidden;
}

.month {
background-color: #004879;
color: white;
width: 100%;
text-align: center;
padding: 2px 0;
font-size: 14px;
}

.day {
color: rgba(0, 0, 0, 0.65);
text-align: center;
font-family: Lato;
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 120% */
text-transform: capitalize;
height: 24px;
}

.weekday {
font-size: 12px;
color: rgba(0, 0, 0, 0.65);
line-height: 1;
padding-bottom: 3px;
}

.appointment-details {
  flex-grow: 1;
}

.detail-title {
  font-size: 12px;
  color: #666;
}
.detail-text {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}
.action-icons-appointment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 20px;
}
.info-text-title {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #666;
}
.info-text-large {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* Badge for billing preference */
.badge {
color: #25B8C2;
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 120% */
letter-spacing: 0.25px;
display: flex;
padding: 4px 8px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
}

.badge-default {
border-radius: 20px;
background: #EBFFF8;
width: 68px;
}


/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}

.expand-action {
display: flex;
align-items: center;
gap: 8px;
color: #1B79A0;
cursor: pointer;
padding: 4px 10px;
border-radius: 5px;
}

.expand-action span {
color: var(--color-Darkblue-000, #1E4670);
text-align: center;
font-family: 'Inter', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-decoration-line: underline;
text-decoration-style: solid;
text-decoration-skip-ink: none;
text-decoration-thickness: auto;
text-underline-offset: auto;
text-underline-position: from-font;
}


.action-icon {
width: 28px;          /* w-7 */
height: 28px;         /* h-7 */
display: flex;
justify-content: center;
align-items: center;
border-radius: 5px;   /* rounded-[5px] */
padding: 5px;         /* pd-5 (assuming you meant padding) */
cursor: pointer;
transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}

.info-text-title-date {
  font-size: 12px;
  color: #666;
}

.sample-card-status {
  color: var(--VibrantDarkBlue, #004879);
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 120% */
letter-spacing: 0.25px;
display: flex;
width: 140px;
padding: 4px 8px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 20px;
background: #E5F1FB;
margin: 4px 0;
}


/* unified pin toggle */
.pin-toggle {
  position: relative;
  cursor: pointer;
}
.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}
.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}
.sample-card-status {
  color: var(--VibrantDarkBlue, #004879);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  width: 140px;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  background: #E5F1FB;
  margin: 4px 0;
}
</style>
